<img
    [alt]="application()"
    [class]="logoClasses()"
    [src]="applicationIconMap[application()]"
    [title]="application()" />
